module.exports = __webpack_public_path__ + "static/media/avatar8.ac049568.jpg";